import PrismicDOM from 'prismic-dom';
import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';
import ContentPost from '../../common/contentPost/Post';
import ContentTitle from '../../common/contentPost/Title';
import ContentTypeTag from '../common/ContentTypeTag';

const BlogPost = (props) => {
  const { blog } = props;

  const body = PrismicDOM.RichText.asHtml(
    blog.content.richText,
    null,
    htmlSerializer
  );

  return (
    <StyledSection>
      <StyledTagWrapper>
        <ContentTypeTag contentType={blog.content_type} />
      </StyledTagWrapper>
      <ContentTitle
        title={blog.title}
        author={blog.author}
        date={blog.publish_date}
        body={body}
      />
      <ContentPost html={body} />
      {blog.body.map((slice) => {
        if (slice.slice_type === 'references') {
          return (
            <References key={slice.id}>
              <ReferenceTitle>References</ReferenceTitle>
              <ContentPost html={slice.primary.reference_list.html} />
            </References>
          );
        }
        return null;
      })}
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  max-width: 950px;
  margin: 0 auto 250px;
  padding-top: 110px;
`;

const StyledTagWrapper = styled.div`
  margin-bottom: 15px;
`;

const References = styled.div`
  border-top: 1px solid rgb(220, 223, 232);
  padding-top: 40px;
`;

const ReferenceTitle = styled.h5`
  font-weight: var(--font-weight-bold);
  margin-bottom: 15px;
`;

const htmlSerializer = (type, element, content) => {
  if (type === 'label') {
    switch (element.data.label) {
      case 'blockquote':
        return `<blockquote class="custom-blockquote">${content}</blockquote>`;
      case 'subscript':
        return `<sub>${content}</sub>`;
      case 'superscript':
        return `<sup>${content}</sup>`;
      default:
        return null;
    }
  }
  return null;
};

export default BlogPost;
